/**
 * The backend's `SpecialDlnFormat` values, as the list endpoint's
 * `parserFormat` filter accepts them. The API takes any string, so this is
 * the set the filter offers, not a validation rule.
 */
export const PARSER_FORMATS = [
  'ai',
  'ocr',
  'qr',
  'manual',
  'noparser',
  'legacy',
  'customerdemo',
  'SIMPLEPARSER',
  'ugl',
  'ugl4',
  'flixbeton',
  'eins_lieferschein',
  'eins_lieferschein_in',
  'schleith',
  'bauelse',
  'eurovia',
  'brz8',
  'qpoint',
  'smart_site_one',
  'edifact_desadv',
] as const;
